type PageMap = Record<string, Record<string, unknown>>;

type GlobFn = (pattern: string, options: { eager: true; import: 'default' }) => Record<string, PageMap>;

/**
 * Pages as baked by the deploy pipeline into the site's
 * `src/vibesites-pages.json` — the full theme → company → property merge,
 * including page-settings changes (visibility, names) made in the editor.
 * The theme's own `pages.json` only carries theme-level settings.
 *
 * Must stay a literal `import.meta.glob(` call so Vite rewrites it at build
 * time; `/src/…` resolves from the project root, so it finds the site's file
 * even when this module lives in a theme package. Outside Vite (or when the
 * file hasn't been baked) this is `null` and callers fall back to `pages.json`.
 */
export const bakedPages: PageMap | null = (() => {
  try {
    const modules = (import.meta as unknown as { glob: GlobFn }).glob('/src/vibesites-pages.json', {
      eager: true,
      import: 'default',
    });
    const pages = Object.values(modules)[0];
    return pages && typeof pages === 'object' && Object.keys(pages).length > 0 ? pages : null;
  } catch {
    return null;
  }
})();
